// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2JWId","inputWrap":"Table_inputWrap__ZQPbj","col":"Table_col__2b3-7","bmiTooltip":"Table_bmiTooltip__1-RKC"};